<script lang="ts">
import { Icon } from '@viamrobotics/prime-core';
import { clickOutside } from '@viamrobotics/prime-core';

import { popupEnter } from '$lib/components/floating/popup-enter';

let isOpen = $state(false);

const closeMenu = () => {
  isOpen = false;
};
</script>

<div
  class="relative z-max flex self-stretch font-public-sans"
  use:clickOutside={closeMenu}
>
  <button
    aria-label="Documentation"
    onclick={() => {
      isOpen = !isOpen;
    }}
    class="flex items-center justify-center h-8 w-8 bg-light hover:bg-medium {isOpen
      ? 'bg-medium'
      : ''}"
  >
    <Icon
      name="book-open"
      class="text-gray-7 w-4 h-4"
    />
  </button>

  {#if isOpen}
    <article
      use:popupEnter
      class="absolute right-0 top-full -mr-1 mt-4 flex max-h-[80vh] w-80 origin-top-right flex-col items-stretch overflow-y-auto border border-medium bg-white text-default shadow-sm"
    >
      <div
        class="border-b border-b-light p-4 text-base font-semibold leading-none text-left"
      >
        Documentation
      </div>

      <nav
        class="flex flex-col border-b border-b-light py-2 text-sm text-subtle-1"
      >
        <a
          href="https://docs.viam.com"
          target="_blank"
          rel="external"
          class="flex items-center gap-3 px-4 py-1.5 hover:bg-medium"
          onclick={closeMenu}
        >
          <div class="text-gray-6">
            <Icon name="book-open" />
          </div>
          Viam Docs
        </a>

        <a
          href="https://docs.viam.com/appendix/apis/"
          target="_blank"
          rel="external"
          class="flex items-center gap-3 px-4 py-1.5 hover:bg-medium"
          onclick={closeMenu}
        >
          <div class="text-gray-6">
            <Icon name="code-braces" />
          </div>
          API Docs
        </a>
      </nav>

      <section>
        <div class="mt-4 flex items-center justify-between px-4">
          <h3
            class="flex font-roboto-mono text-xs uppercase leading-6 tracking-wider text-subtle-2"
          >
            SDK DOCS
          </h3>
        </div>

        <ul class="py-2">
          <li>
            <a
              href="https://python.viam.dev"
              target="_blank"
              rel="external"
              class="flex items-center gap-3 px-4 py-1.5 hover:bg-medium text-sm text-subtle-1"
              onclick={closeMenu}
            >
              <div class="text-gray-6">
                <Icon name="language-python" />
              </div>
              Python
            </a>
          </li>

          <li>
            <a
              href="https://ts.viam.dev"
              target="_blank"
              rel="external"
              class="flex items-center gap-3 px-4 py-1.5 hover:bg-medium text-sm text-subtle-1"
              onclick={closeMenu}
            >
              <div class="text-gray-6">
                <Icon name="language-typescript" />
              </div>
              TypeScript
            </a>
          </li>

          <li>
            <a
              href="https://pkg.go.dev/go.viam.com/rdk"
              target="_blank"
              rel="external"
              class="flex items-center gap-3 px-4 py-1.5 hover:bg-medium text-sm text-subtle-1"
              onclick={closeMenu}
            >
              <div class="text-gray-6">
                <Icon name="language-go" />
              </div>
              Go
            </a>
          </li>
          <li>
            <a
              href="https://cpp.viam.dev"
              target="_blank"
              rel="external"
              class="flex items-center gap-3 px-4 py-1.5 hover:bg-medium text-sm text-subtle-1"
              onclick={closeMenu}
            >
              <div class="text-gray-6">
                <Icon name="language-cpp" />
              </div>
              C++
            </a>
          </li>
          <li>
            <a
              href="https://flutter.viam.dev"
              target="_blank"
              rel="external"
              class="flex items-center gap-3 px-4 py-1.5 hover:bg-medium text-sm text-subtle-1"
              onclick={closeMenu}
            >
              <div class="text-gray-6">
                <Icon name="viam-flutter" />
              </div>
              Flutter
            </a>
          </li>
        </ul>
      </section>
    </article>
  {/if}
</div>
